import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "ovamx:admin_token";
const Ctx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = anon, object = authed
  const token = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();

  const setToken = (t) => {
    try { t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY); } catch {}
  };

  const hydrate = useCallback(async () => {
    const t = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();
    if (!t) { setAdmin(false); return; }
    try {
      const { data } = await axios.get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${t}` } });
      setAdmin(data);
    } catch {
      setToken(null);
      setAdmin(false);
    }
  }, []);

  useEffect(() => { hydrate(); }, [hydrate]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    setToken(data.access_token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    setToken(null);
    setAdmin(false);
  };

  const apiGet = (path) => {
    const t = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();
    return axios.get(`${API}${path}`, { headers: { Authorization: `Bearer ${t}` } });
  };

  const apiPost = (path, body) => {
    const t = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();
    return axios.post(`${API}${path}`, body, { headers: { Authorization: `Bearer ${t}` } });
  };

  const apiPatch = (path, body) => {
    const t = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();
    return axios.patch(`${API}${path}`, body, { headers: { Authorization: `Bearer ${t}` } });
  };

  const apiDelete = (path) => {
    const t = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();
    return axios.delete(`${API}${path}`, { headers: { Authorization: `Bearer ${t}` } });
  };

  const apiDownload = async (path, filename) => {
    const t = (() => { try { return localStorage.getItem(KEY); } catch { return null; } })();
    const res = await axios.get(`${API}${path}`, {
      headers: { Authorization: `Bearer ${t}` },
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Ctx.Provider value={{ admin, token, login, logout, apiGet, apiPost, apiPatch, apiDelete, apiDownload, API }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAdminAuth = () => useContext(Ctx);
